import { Box, Stack, useTheme } from "@mui/material";

const SectionLayout = ({
    children
}) => {
    const theme = useTheme();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper
                }}
                className="navigationTopSpacing"
            >
                <Stack
                    direction='column'
                    alignItems='center'
                    className="bodySideMargin1 sectionRadius sectionInSidePadding"
                    sx={{
                        backgroundColor: theme.palette.background.default,
                        mt: 2
                    }}
                >
                    {children}
                </Stack>
            </Box>
        </>
    );
}

export default SectionLayout;